module.exports = __webpack_public_path__ + "img/preview-13.392843a0.png";